import React, { useRef, useState } from "react";
import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { detailedIncidentRegister } from "../../../../redux/slice/DetailReportSummarySlice";
import { StatusCode } from "../../../../services/helper";
import ButtonLoader from "../../../../components/Common/ButtonLoader";
import { usePic } from "../../../../context/PicProvider";
import ProductTableView from "../common/ProductTableView";
import ProductDetailsButtonView from "../common/ProductDetailsButtonView";
import PhotoAddIcon from "../../../../Assets/icons/photo-scan-icon.svg";

const DetailedIncidentReportSummary = () => {
  const {
    detailFromInfoFormData,
    detailReportSummaryFormData,
    detailReportActionData,
    detailReportFilledItem,
    status,
  } = useSelector((state) => state.DetailReport);
  const [usedItemData, setUsedItemData] = useState(
    detailReportFilledItem?.formDataArray
  );

  const { quichReportData } = useSelector((state) => state.QUICKREPORT);

  const dispatch = useDispatch();
  const { theme, setTheme, setSuccessPopup } = usePic();
  const inputRef = useRef();

  const getProducts = (id) => {
    const product = quichReportData?.products?.find(
      (product) => product?._id === id
    );
    return product?.description ?? "";
  };

  const reportSubmitHandler = async (e) => {
    e.preventDefault();
    const item_used_data = detailReportFilledItem?.formDataArray?.map(
      ({ item, quantity, usedBy }) => ({
        full_name: usedBy?.value,
        used_quantity: Number(quantity?.value),
        title: getProducts(item?.value),
        product_id: item?.value,
      })
    );

    const insident_person_data = detailReportActionData?.formArr.map(
      ({
        incidentOutcome,
        injuryClassification,
        injuryDetail,
        injuryType,
        otherDetail,
        incidentOutcomeOther,
        personOfTreatment,
      }) => ({
        full_name: personOfTreatment?.value,
        injury_type: injuryType?.value,
        injury_classification: injuryClassification?.value,
        injury_details: injuryDetail?.value,
        outcome:
          incidentOutcome?.value === "Other"
            ? incidentOutcomeOther?.value
            : incidentOutcome?.value,
        more_details: otherDetail?.value,
      })
    );

    // const insident_person = [
    //   {
    //     user_id: "65e062f2ee657dd69d0cedf2",
    //     full_name: "max richard",
    //     injury_type: "Burns",
    //     injury_classification:
    //       "Moderate: Second-degree burns that cover about 10% of the body",
    //     injury_details: "Sustained injury while trying to put out a cigareet",
    //     outcome: "Was taken to the hospital",
    //     more_details: "more details",
    //   },
    //   {
    //     user_id: "65e076e33e89cd4490402c97",
    //     full_name: "Vikram sood",
    //     injury_type: "Burns",
    //     injury_classification:
    //       "Moderate: Second-degree burns that cover about 10% of the body",
    //     injury_details: "Sustained injury while trying to put out a cigareet",
    //     outcome: "Was taken to the hospital",
    //     more_details: "test",
    //   },
    // ];
    const payload = {
      item_used: item_used_data,
      incident_date: detailReportSummaryFormData?.date?.value,
      incident_time: detailReportSummaryFormData?.time?.value,
      category_of_incident: detailReportSummaryFormData?.category?.value,
      classification: detailReportSummaryFormData?.classification?.value,
      description: detailReportSummaryFormData?.summary?.value,
      incident_person: insident_person_data,
      location_of_incident: quichReportData?.kit_data?.location_name,
      area_of_incident: quichReportData?.kit_data?.area,
      incident_picture: theme,
      more_details: detailReportActionData?.formArr[0]?.otherDetail?.value,
      injury_details: detailReportActionData?.formArr[0]?.injuryDetail?.value,
      kit_id: quichReportData?.kit_data?._id,
      company_id: quichReportData?.kit_data?.company_id,
      reported_by: {
        first_name: detailFromInfoFormData?.firstName?.value,
        last_name: detailFromInfoFormData?.lastName?.value,
        email: detailFromInfoFormData?.email?.value,
        contact_number: detailFromInfoFormData?.phoneNumber?.value,
        country_code: detailFromInfoFormData?.phoneNumberCode?.value,
      },
    };

    try {
      const response = await dispatch(detailedIncidentRegister(payload));
      const result = response?.payload;
      if (result?.status === 200) {
        setUsedItemData([]);
        setSuccessPopup({
          open: true,
          title: "Submission Complete",
          primaryText: "Done",
          message: "Your report has been submitted successfully.",
          primaryURL: "/standardwithquickreport",
          child: null,
        });
      }
    } catch (error) {
      // Handles errors from the action
      toast.error("Error:", error);
    }
  };

  const getProductName = (id) => {
    const currentItem = quichReportData?.products?.find(
      (item) => item?._id === id
    );
    return currentItem?.description ?? "";
  };

  const handleAddPhotos = (e) => {
    const filesList = Array.from(e.target.files);
    if (filesList.length > 0) {
      const allAreImages = filesList.every((file) =>
        file.type.startsWith("image/")
      );
      if (allAreImages) {
        const files = e.target.files;
        setTheme([...theme, ...files]);
        e.target.value = "";
      } else {
        toast.error("Please add valid image file");
      }
    }
  };

  const handleQuantityChange = (e, index) => {
    let data = [...(usedItemData ?? [])];
    let newQuantity = Number(e.target.value);
    if (newQuantity < 1) {
      toast.error("Minimum quantity is 1");
      return;
    }
    const currentProduct = quichReportData?.products?.find(
      (item) => item._id === data[index]?.item?.value
    );
    if (currentProduct && newQuantity > currentProduct?.current_quantity) {
      toast.error(`Maximum quantity is ${currentProduct?.current_quantity}`);
      return;
    }
    data[index] = {
      ...data[index],
      quantity: {
        ...data[index].quantity,
        value: newQuantity,
      },
    };
    setUsedItemData(data);
  };

  const getTableBody = (data) => {
    const tableBody =
      data?.length > 0
        ? data?.map((item, index) => {
            return {
              cell: [
                {
                  data: (
                    <div>
                      <h6>{getProductName(item?.item?.value)}</h6>
                    </div>
                  ),
                  align: "start",
                },
                {
                  data: (
                    <Stack
                      direction="horizontal"
                      className="justify-content-center"
                    >
                      <Form.Control
                        type="number"
                        value={item?.quantity?.value}
                        min="1"
                        placeholder="Qty"
                        onChange={(e) => {
                          handleQuantityChange(e, index);
                        }}
                        size="sm"
                        style={{ width: "70px", height: "40px" }}
                        className="text-center"
                      />
                    </Stack>
                  ),
                  align: "center",
                },
              ],
            };
          })
        : [];
    return tableBody;
  };

  const groupedData = usedItemData?.reduce((acc, item) => {
    const personName = item?.usedBy?.value;
    if (!acc[personName]) {
      acc[personName] = [];
    }
    acc[personName]?.push(item);
    return acc;
  }, {});

  const result = Object.keys(groupedData)?.map((key) => ({
    name: key,
    array: groupedData[key],
  }));

  return (
    <div className="flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <h6 className="mb-0 fw-bold text-center">Reported By</h6>
        <div className="summaryinfocontainer">
          <div className="incidentmadeinfo">
            <hr />
            <Stack gap={2}>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Name:</h5>
                <span className="text-break">
                  {detailFromInfoFormData?.firstName?.value}{" "}
                  {detailFromInfoFormData?.lastName?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Contact Number: </h5>
                <span>
                  {detailFromInfoFormData?.phoneNumberCode?.value}
                  {detailFromInfoFormData?.phoneNumber?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Email: </h5>
                <span className="text-break">
                  {detailFromInfoFormData?.email?.value}
                </span>
              </div>
            </Stack>
          </div>
          <div className="incidentmadeinfo mt-4 text-center">
            <h6 className="fw-bold">Type of Incident</h6>
            <hr />
            <Stack gap={2}>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Category: </h5>
                <span className="text-break">
                  {detailReportSummaryFormData?.category?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Classification: </h5>
                <span className="text-break text-start">
                  {detailReportSummaryFormData?.classification?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Date: </h5>
                <span className="text-break">
                  {detailReportSummaryFormData?.date?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Time: </h5>
                <span className="text-break">
                  {detailReportSummaryFormData?.time?.value}
                </span>
              </div>
            </Stack>
          </div>
          <div className="incidentmadeinfo mt-4">
            <h6 className="fw-bold text-center">Summary of Incident</h6>
            <hr />
            {detailReportSummaryFormData.summary.value ? (
              <div className="overflow-y-auto" style={{ maxHeight: "400px" }}>
                <p className="text-break">
                  {detailReportSummaryFormData.summary.value}
                </p>
              </div>
            ) : (
              <p className="mb-0">No summary found</p>
            )}
          </div>
          <div className="incidentmadeinfo mt-4">
            <h6 className="fw-bold text-center">Photos of Incident</h6>
            <hr />
            <div className="d-flex flex-column row-gap-3">
              <div className="d-flex">
                <img
                  src={PhotoAddIcon}
                  alt="photo-add-icon"
                  style={{ borderRadius: "8px 0px 0px 8px" }}
                />
                <input
                  type="file"
                  accept="image/*"
                  className="d-none"
                  ref={inputRef}
                  multiple
                  onChange={handleAddPhotos}
                />
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => inputRef.current.click()}
                  className="button_custom text-black w-100 btn fw-bold"
                  style={{ fontSize: 18, borderRadius: "0px 8px 8px 0px" }}
                >
                  Take Photo of Location
                </Button>
              </div>
              {theme.length > 0 && (
                <Row className="row-gap-3 collapse show">
                  {theme.map((selectItem, index) => (
                    <Col
                      sm={6}
                      md={3}
                      xl={2}
                      key={index}
                      className="d-flex flex-column row-gap-1 fade show"
                    >
                      <div className="position-relative image-container">
                        <img
                          style={{
                            backgroundColor: "#D4D4D4",
                            display: "inline-block",
                            height: "150px",
                            width: "100%",
                          }}
                          src={URL.createObjectURL(selectItem)}
                          alt={`image-${index + 1}`}
                        />
                        <div className="delete-overlay">
                          <button
                            className="btn text-center w-100"
                            onClick={(event) => {
                              event.preventDefault();
                              let data = [...theme];
                              data.splice(index, 1);
                              setTheme([...data]);
                            }}
                            style={{ color: "#FA0000" }}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </div>
          <div className="incidentmadeinfo mt-3">
            <h6 className="fw-bold text-center">
              First Aid Kit and Location Details
            </h6>
            <hr />
            <h6 className="mb-3 fw-bold text-center">
              <span> {quichReportData?.kit_data?.brand}</span>
              <span className="ms-2">
                {quichReportData?.kit_data?.model_number}
              </span>
              <div> {quichReportData?.kit_data?.product_name}</div>
            </h6>
          </div>
          <ProductDetailsButtonView />
          {usedItemData?.length > 0 && (
            <Stack className="row-gap-3 mt-2">
              {result.map((item, index) => {
                return (
                  <ProductTableView
                    key={index}
                    tableHeader={[
                      { name: `Used by ${item.name}`, align: "left" },
                      { name: "Quantity", align: "center" },
                    ]}
                    tableBody={getTableBody(item.array)}
                  />
                );
              })}
            </Stack>
          )}
        </div>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink className="nav-link" to="/detailedreporforfilleditem">
          <Button variant="dark h-100" className="fw-bold">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            type="submit"
            onClick={(e) => reportSubmitHandler(e)}
            className="button_custom text-black fw-bold d-flex align-items-center justify-content-center"
            disabled={status === StatusCode.LOADING}
          >
            {status === StatusCode.LOADING ? <ButtonLoader /> : "Submit Report"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DetailedIncidentReportSummary;
